import { Observable } from 'rxjs'

import { ApplicationResourceType } from './application.entity'

import { CopyResourceSseMessageType } from '../model/copy-resource.model'

export enum ExistingResourceConflictType {
  NAME,
  RESOURCE_DEFINITION_ID,
}
export enum ExistingResourceImportStrategy {
  Replace = 'REPLACE',
  Add = 'ADD',
  Keep_From_Target = 'KEEP_FROM_TARGET',
}
export type ExistingResource = {
  resourceId: string
  copyTaskId: string
  conflictType: ExistingResourceConflictType
  importStrategy: ExistingResourceImportStrategy
  resourceName: string
  conflictedValue: unknown
  conflictTypeList: unknown[]
}
export type ImportResourceSessionResponse = {
  sessionId: string
  conflicts: ExistingResource[]
  numberOfElementsToImport: number
}

export enum ImportDecision {
  Resume = 'resume',
  Abort = 'abort',
}

export type ImportSseConnectionsMessages = {
  status: CopyResourceSseMessageType
  errorMessage: string
}

export type ImportSseConnections = Partial<
  Record<ApplicationResourceType, Observable<MessageEvent<ImportSseConnectionsMessages>>>
>

export function isImportSuccessful(response: void | ImportSseConnectionsMessages): boolean {
  return response && response.status === CopyResourceSseMessageType.SUCCESS
}
